<template>
  <div class="tech-jumbotron flex-1">
    <div class="flex items-center flex-col">
      <div class="tech-jumbotron-info">
        Hi, we're still processing your application
        if it has been more than 2 weeks,
        email us at
        <a
          :href="'mailto:' + email"
          target="_blank"
        >&lt;{{email}}&gt;</a>
      </div>
      <div class="tech-jumbotron-img">
        <img src="@/assets/image/consultant_process.png" alt="process" />
      </div>
    </div>
  </div>
</template>

<script>
import * as config from "@/config";
export default {
  data() {
    return {
      email: config.DEFAULT_CONTACT_EMAIL
    };
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
  }
};
</script>